var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcBrandInstagramSolid = function SvgIcBrandInstagramSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M15.638 3H8.362A5.37 5.37 0 0 0 3 8.362v7.276A5.37 5.37 0 0 0 8.362 21h7.276A5.37 5.37 0 0 0 21 15.638V8.362A5.37 5.37 0 0 0 15.638 3m3.551 12.638a3.55 3.55 0 0 1-3.551 3.551H8.362a3.55 3.55 0 0 1-3.551-3.551V8.362a3.55 3.55 0 0 1 3.551-3.551h7.276a3.55 3.55 0 0 1 3.551 3.551z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 7.345A4.66 4.66 0 0 0 7.345 12 4.66 4.66 0 0 0 12 16.655 4.66 4.66 0 0 0 16.655 12 4.66 4.66 0 0 0 12 7.345m0 7.5a2.845 2.845 0 1 1 0-5.69 2.845 2.845 0 0 1 0 5.69M16.665 8.495a1.116 1.116 0 1 0 0-2.231 1.116 1.116 0 0 0 0 2.231"
  })));
};
export default SvgIcBrandInstagramSolid;